export default __webpack_public_path__ + "static/media/logoRedBlack.3f7ed33f.svg";